import { render, staticRenderFns } from "./commissions.vue?vue&type=template&id=4c999d10&"
import script from "./commissions.vue?vue&type=script&lang=ts&"
export * from "./commissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports